import { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { COMPARE_FAQ, faqSchema } from '../../data/compare';

// Questions people ask, plus FAQPage structured data for only these questions.
export default function CompareFaq() {
  const [open, setOpen] = useState(null);

  useEffect(() => {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify(faqSchema(COMPARE_FAQ));
    document.head.appendChild(el);
    return () => el.remove();
  }, []);

  return (
    <section className="mt-10 max-w-3xl" data-testid="compare-faq">
      <h2 className="text-base font-bold text-gray-900 md:text-lg">Questions people ask</h2>
      <div className="mt-2">
        {COMPARE_FAQ.map((f, i) => (
          <div key={f.q} className="border-b border-gray-200">
            <button type="button" onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i}
              data-testid={`faq-${i}`}
              className="flex w-full items-center justify-between gap-3 py-3 text-left text-sm font-medium text-gray-900">
              {f.q}
              <ChevronDown size={16} className={`shrink-0 text-gray-400 transition-transform ${open === i ? 'rotate-180' : ''}`} aria-hidden="true" />
            </button>
            {open === i && <p className="pb-3.5 text-sm leading-relaxed text-gray-600">{f.a}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
